import { createModel } from '@rematch/core';

type ShareCenterState = {
  open: boolean;
  isConsentModalOpen: boolean;
  isConsentAccepted: boolean;
  isLegalTextDisplayed: boolean;
};

export const sharedRepStorageKey = 'sharedReps';

const toggleOpen = function handleToggleOpen(
  state: ShareCenterState
): ShareCenterState {
  return {
    ...state,
    open: !state.open
  };
};

const openCloseConsentModal = function handleCloseConsentModal(
  state: ShareCenterState,
  openClose: boolean
): ShareCenterState {
  return {
    ...state,
    isConsentModalOpen: openClose,
    isLegalTextDisplayed: false,
    isConsentAccepted: false
  };
};

const toggleLegalText = function handleToggleLegalText(
  state: ShareCenterState
): ShareCenterState {
  return { ...state, isLegalTextDisplayed: !state.isLegalTextDisplayed };
};

const toggleConsentModalOpen = function handleToggleConsentModalOpen(
  state: ShareCenterState
): ShareCenterState {
  return {
    ...state,
    isConsentModalOpen: !state.isConsentModalOpen
  };
};

const toggleConsentAcceptance = function handleToggleConsentAcceptance(
  state: ShareCenterState
): ShareCenterState {
  return {
    ...state,
    isConsentAccepted: !state.isConsentAccepted
  };
};

const shareCenter = createModel({
  state: {
    open: false,
    isConsentModalOpen: false,
    isLegalTextDisplayed: false,
    isConsentAccepted: false
  },
  reducers: {
    toggleOpen,
    toggleConsentModalOpen,
    toggleLegalText,
    toggleConsentAcceptance,
    openCloseConsentModal
  }
});

export default shareCenter;
